import { Component, h, Host, Prop } from '@stencil/core';
import { getSitefinityValue } from '../../../lib/helper/global.helper';

@Component({
  tag: 'envc-t-bild-farbe',
  styleUrl: 'envc-t-bild-farbe.scss',
  shadow: false,
  scoped: false
})
export class EnvcTBildFarbe {
  @Prop() wrapperClasses: string;
  @Prop() trackingAttributes: string;
  @Prop() anchorAttribute: string;

  @Prop() linkClasses: string;
  @Prop() linkUrl: string;
  @Prop() linkTitle: string;
  @Prop() targetAttribute: string;
  @Prop() noFollowAttribute: string;
  @Prop() dataLayerEntry: string;

  @Prop() headline: string;
  @Prop() text: string;

  render() {
    return (
      <Host>
        <article
          data-elbcontext={getSitefinityValue(this.trackingAttributes)}
          id={getSitefinityValue(this.anchorAttribute)}
          data-tpl="tea01"
          class={this.wrapperClasses}
        >
          <a
            href={this.linkUrl}
            title={this.linkTitle}
            class={this.linkClasses}
            target={this.targetAttribute}
            rel={getSitefinityValue(this.noFollowAttribute)}
            data-layer-click=""
            data-layer-entry={this.dataLayerEntry}
          >
            <slot name="image"></slot>

            <header>
              {(this.headline) && <h3 class="headline">{this.headline}</h3>}
              {(this.text) && <p>{this.text}</p>}
            </header>

            <slot name="logo"></slot>
          </a>
        </article>
      </Host>
    );
  }
}
